/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { LOCAL_STORAGE } from "../../../globals/globals";
import { isJwtExpired } from "../../../utils/helpers";
import { IProfile } from "../admin/types";

export interface IAuthenticationState {
  username: string;
  isLoggedIn: boolean;
  idToken?: string;
  refreshToken?: string;
  profileId: number;
  profile?: IProfile;
}

export interface IRetrievedTokenData {
  idToken: string;
  refreshToken: string;
  profile?: IProfile;
}

const getItemFromLocalStorage = (key: string): string | undefined => {
  return localStorage.getItem(key) || undefined;
};
const tokenData = (): string | undefined => {
  const token = getItemFromLocalStorage(LOCAL_STORAGE.TOKEN);
  if (!token || isJwtExpired(token)) {
    return undefined;
  }
  return token;
};

const profileData = (): IProfile | undefined => {
  const profileString = getItemFromLocalStorage(LOCAL_STORAGE.PROFILE);
  if (!profileString) {
    return undefined;
  }
  return JSON.parse(profileString);
};

export const initialAuthenticationState: IAuthenticationState = {
  username: getItemFromLocalStorage(LOCAL_STORAGE.USER) || "unknown",
  idToken: tokenData(),
  isLoggedIn: tokenData() != null,
  refreshToken: getItemFromLocalStorage(LOCAL_STORAGE.REFRESH_TOKEN),
  profile: profileData(),
  profileId: profileData()?.id || 0,
};
